import Icon from 'flow/components/ui-components/Icon';
import IconButton from 'flow/components/ui-components/IconButton';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    generationIsInProgress: boolean;
    onClick: () => void;
}

const ButtonGenerate = ({ generationIsInProgress, onClick }: Props) => {
    const { i18next } = useAppContext();

    return (
        <IconButton
            onClick={onClick}
            disabled={generationIsInProgress}
            className={`flex h-10 shrink-0 items-center gap-1 rounded bg-gray-200 px-2 transition-all duration-200 ${generationIsInProgress ? 'opacity-40' : ''}`}
        >
            <Icon iconKey="article" size="1.25rem" className="text-gray-600" />
            <span className="text-xs text-gray-800 antialiased">
                {i18next.t('ai.transcript.transcribe_call')}
            </span>
        </IconButton>
    );
};

export default ButtonGenerate;
